import { render, staticRenderFns } from "./AwardCompay.vue?vue&type=template&id=1a22bbca&scoped=true"
import script from "./AwardCompay.vue?vue&type=script&lang=js"
export * from "./AwardCompay.vue?vue&type=script&lang=js"
import style0 from "./AwardCompay.vue?vue&type=style&index=0&id=1a22bbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22bbca",
  null
  
)

export default component.exports